import styled from "@emotion/styled";

export const NumberedList = styled.ul`
  list-style-type: decimal;
  list-style-position: inside;
`;
